import { useEffect, useMemo, useState } from "react";
import AdminTopbar from "../../components/topbars/AdminTopbar";
import ResourceTable from "../../components/table/ResourceTable";
import "./ResourceList.css";

const ResourceList = ({ title, subtitle, fetchData, columns, searchKeys = [], secondaryActionLabel, onSecondaryAction }) => {
    const [rows, setRows] = useState([]);
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const loadData = async () => {
        setLoading(true);
        setError("");

        try {
            const data = await fetchData();
            setRows(Array.isArray(data) ? data : []);
        } catch (requestError) {
            setError(requestError.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const filteredRows = useMemo(() => {
        if (!query.trim()) {
            return rows;
        }

        const normalizedQuery = query.toLowerCase();

        return rows.filter((row) => {
            return searchKeys.some((key) => {
                const value = row[key];

                if (value === null || value === undefined) {
                    return false;
                }

                return String(value).toLowerCase().includes(normalizedQuery);
            });
        });
    }, [rows, query, searchKeys]);

    return (
        <>
            <AdminTopbar
                title={title}
                subtitle={subtitle}
                secondaryActionLabel={secondaryActionLabel}
                onSecondaryAction={onSecondaryAction}
            />

            <section className="resource-list">
                <div className="resource-list__header">
                    <div>
                        <h2>{title}</h2>
                        <p>{filteredRows.length} registros encontrados</p>
                    </div>
                </div>

                <label className="resource-list__search">
                    <span>⌕</span>
                    <input
                        value={query}
                        onChange={(event) => setQuery(event.target.value)}
                        placeholder={`Buscar en ${title.toLowerCase()}...`}
                    />
                </label>

                {error && <div className="resource-list__error">{error}</div>}

                {loading ? (
                    <div className="resource-list__loading">
                        <div className="resource-list__loader" />
                        <p>Cargando datos...</p>
                    </div>
                ) : (
                    <ResourceTable
                        columns={columns}
                        rows={filteredRows}
                        emptyMessage={`No hay registros cargados en ${title.toLowerCase()}.`}
                    />
                )}
            </section>
        </>
    );
};

export default ResourceList;